var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvlPortableEmergency = function SvgAvlPortableEmergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD8082",
    fillRule: "evenodd",
    d: "m17.15 6.698-9.878-.32v15.006l9.67-.42zm-2.695 2.62h-4.87v3.55h4.87z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M7.543 3.206v2.361c-.864.337-1.501 1.05-1.501 1.951v11.485c0 1.766 1.778 3.072 3.782 3.072h4.537c2.033 0 3.597-1.34 3.597-3.082V7.518c0-1.265-1.257-2.16-2.631-2.16h-5.323V3.205c0-.823-.628-1.28-1.23-1.28-.616 0-1.231.459-1.231 1.28m1.13 3.422h6.664c.745 0 1.21.473 1.21.89v11.475c0 .917-.975 1.801-2.36 1.801H9.823c-1.378 0-2.361-.875-2.361-1.8V7.517c0-.417.465-.89 1.21-.89",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M9.732 9.307h4.537v3.373H9.732zm4.637 3.473H9.632V9.207v3.573zM9.632 8.106a1.1 1.1 0 0 0-1.1 1.1v3.574a1.1 1.1 0 0 0 1.1 1.1h4.737a1.1 1.1 0 0 0 1.1-1.1V9.207a1.1 1.1 0 0 0-1.1-1.1zm4.978 5.645a1 1 0 0 0 .76-.97V9.206a1 1 0 0 0-1.001-1H9.63h4.738a1 1 0 0 1 1 1v3.573a1 1 0 0 1-.759.971",
    clipRule: "evenodd"
  })));
};
export default SvgAvlPortableEmergency;